module Easypass {
    class InfosParametresController extends Core.InfosParametresController {
		deleteAccount = () => {
			this.deleteAccountInternal();
		}
    }
    angular.module('easypass').controller('infosParametresController', ['userService', '$rootScope', "$state", "helperService", InfosParametresController]);
}